import { useContext } from "react"
import { AuthContext } from "@/contexts/AuthContext"
import { ModalContext } from "@/contexts/ModalContext"

export default function LogoutModal() {
  const { logout } = useContext(AuthContext)
  const { closeModal } = useContext(ModalContext)
  const handleClick = () => {
    logout()
    closeModal()
  }
  return (
    <div>
      <p className="text-sm text-center">Don’t forget to check out our huge selection of casino and sports promotions before you leave!</p>
      <button onClick={handleClick} className="bg-red-700 text-white py-3 font-medium w-full rounded text-sm mt-4">
        <span>Logout</span>
      </button>
    </div>
  )
}